<template>
	<div class="w-full">
		<div class="float-tile white-tile top-tile" />
		<div
			class="float-tile transparent-tile left-24 -top-14 bg-gradient-to-b from-blue-start to-blue-end top-tile"
		/>
		<div class="flex justify-center  min-h-screen items-center z-10 relative">
			<div class="w-full md:w-8/12 xl:w-4/12 max-w-lg">
				<div class="rounded p-5">
					<logo class="h-20 mb-8 mx-auto" />
					<div class="card-body">
						<div v-if="error" class="bg-red text-white mb-8">{{ error }}</div>
						<form action="#" @submit.prevent="submit">
							<div class="mb-4 relative text-left">
								<label class="font-medium block pb-3 text-sm dark:text-white"
									>E-mail</label
								>
								<input
									class="block bg-bs-gray rounded-lg px-5 py-3 w-full outline-none text-bs-gray-dark"
									id="email"
									type="text"
									autofocus
									placeholder="Enter your email"
									v-model="form.email"
								/>
							</div>
							<div class="mb-4 relative text-left">
								<label class="font-medium block pb-3 text-sm dark:text-white"
									>Password</label
								>
								<input
									class="block bg-bs-gray rounded-lg px-5 py-3 w-full outline-none text-bs-gray-dark"
									id="password"
									type="password"
									placeholder="Enter your password"
									v-model="form.password"
								/>
							</div>

							<div class="text-left">
								<button type="submit" class="btn-primary w-full mt-4">
									Login
								</button>
							</div>
						</form>
						<div class="mt-8 mb-4 flex gap-4">
							<button class="facebook" @click.prevent="loginWithFb">
								<font-awesome-icon
									:icon="['fab', 'facebook']"
									class="w-4 mr-3"
									size="lg"
									
								/>
								<span class="w-10/12">Login with Facebook</span>
							</button>
						
							<button class="google" @click.prevent="loginWithGoogle">
								<font-awesome-icon
									:icon="['fab', 'google']"
									class="w-4 mr-3"
									size="lg"
								/>
								<span class="w-10/12">Login with Google</span>
							</button>
						</div>
						<div class="mt-8">
							<p class="dark:text-white">Don't have an account? <router-link to="/register" class="font-bold text-bs-blue-dark">Sign up now</router-link></p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="float-tile white-tile fixed-bottom-tile-position bottom-tile" />
		<div
			class="float-tile transparent-tile right-24 -bottom-20 bg-gradient-to-b from-green-start to-green-end bottom-tile"
		/>
	</div>
</template>

<script>
import firebase from '@/firebase'
import { mapState } from 'vuex';
import Logo from '@/components/atoms/Logo.vue';
export default {
  components: { Logo },
	data () {
		return {
			form: {
				email: "",
				password: "",
				loading: false
			},
			error: null,
		};
	},
	computed: {
		...mapState(['theme'])
	},
	methods: {
		submit () {
			firebase
				.auth()
				.signInWithEmailAndPassword(this.form.email, this.form.password)
				.then(() => {
					this.navigate()
				})
				.catch((err) => {
					this.error = err.message;
				});
		},
		loginWithFb: function () {
			console.log('login in with facebok')
			this.loading = true;
			var provider = new firebase.auth.FacebookAuthProvider();
			provider.addScope('public_profile');
			provider.addScope('email');
			
			firebase.auth().signInWithPopup(provider).then(() => {
				this.navigate()
			}).catch(e => {
				this.loading = false;
				console.log(e)
			})
		},
		loginWithGoogle: function () {
			var provider = new firebase.auth.GoogleAuthProvider();
			firebase.auth().signInWithPopup(provider).then(() => {
				this.navigate()

			}).catch(e => {
				this.loading = false;
				console.log(e)
			})
		},
		navigate: async function () {
			let user = await firebase.getCurrentUser();
			let token = await user.getIdToken();
			
			this.$store.commit("setAccessToken", token);
			this.$store.commit("setUser", user.toJSON());
			let t = token.split('.')[1]
			let {roles} = JSON.parse(atob(t))
		
			if (!roles || roles && roles.indexOf('registered') === -1) {
				console.log('REGISTERING NEW USER')
				
				this.$store.dispatch('updateDevice', {
					uuid: localStorage.getItem('_devK'),
				}).then(() => {
					user.getIdToken(true).then(newToken => {
						console.log('newToken', newToken, token)
						this.$store.commit("setAccessToken", newToken);
						this.$router.replace({ name: "Home" });
					})
				})
			} else {
				console.log('USER ALREADY EXISTS')
				this.$router.replace({ name: "Home" });
			}
			
		}
	},

};
</script>

<style>

</style>
